// axios
import axios from "axios";

const baseURL = "";

const instance = axios.create({
  baseURL: "https://cotizador.socasesores.com/apipro/",
});

// -----------------------------------------------------------------------------
// DEBUG ValorSOC — console.log cuando el backend responde con valorSocDebug
// (index_test.php / index.php + ValorSocCatalog.inc.php con VALORSOC_DEBUG = true).
// Pon VALORSOC_CONSOLE_DEBUG = false para apagar.
// IMPORTANTE: npm run build (o serve) y que apipro tenga el PHP con el puente.
// -----------------------------------------------------------------------------
const VALORSOC_CONSOLE_DEBUG = true;

if (VALORSOC_CONSOLE_DEBUG) {
  console.log(
    "[ValorSOC] Debug de consola ACTIVO — espera ListaFinancieras / ListaBancos / ListaCasoEstatus / DameProductosValorSoc / DameJerarquiaValorSoc. Si solo ves 'Sin ministraciones' y no este mensaje al recargar, el dist no tiene este axios.js."
  );

  instance.interceptors.response.use(
    (response) => {
      try {
        let data = response && response.data;
        if (typeof data === "string") {
          try {
            data = JSON.parse(data);
          } catch (e) {
            data = null;
          }
        }
        if (data && data.valorSocDebug) {
          const dbg = data.valorSocDebug;
          const metodo =
            (response.config &&
              response.config.data &&
              (typeof response.config.data === "string"
                ? (JSON.parse(response.config.data).strMetodo || "")
                : response.config.data.strMetodo)) ||
            "";
          console.log(
            "[ValorSOC] OK — backend envió valorSocDebug metodo:",
            metodo || "(desconocido)",
            "estado:",
            dbg.estado,
            "base:",
            dbg.baseUrl
          );
          console.log("[ValorSOC] detalle:", dbg);
          if (Array.isArray(dbg.llamadas)) {
            dbg.llamadas.forEach((c) => {
              console.log(
                "[ValorSOC] API:",
                (c && c.api) || "?",
                "| URL:",
                (c && c.url) || "(sin llamada HTTP)",
                "| ok:",
                c && c.ok,
                "|",
                (c && c.motivo) || ""
              );
            });
          }
        }
      } catch (e) {
        // no romper respuestas normales
      }
      return response;
    },
    (error) => Promise.reject(error)
  );
}

export default instance;
